import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { Box, Stack } from '@mui/material';
import { MathJax } from 'better-react-mathjax';
import { memo, useState } from 'react';
import Markdown from 'react-markdown';
import { toast } from 'react-toastify';

const AiChatHistory = ({ chat }) => {
  const [mouseOver, setMouseOver] = useState(false);

  const isSentType = chat.type === 'sent';

  const copyToClipboard = () => {
    const clearText = chat.text.replace(/<br\/>/g, '\n');
    navigator.clipboard.writeText(clearText);
    toast.success('Copied to clipboard');
  };

  const chatBoxStyle = () => {
    const style = {};
    if (isSentType) {
      style.marginLeft = '50px';
      style.marginRight = '5px';
      style.backgroundColor = '#00A1FF';
      style.color = 'white';
    } else {
      style.backgroundColor = '#F0F7FF';
      style.marginRight = '50px';
      style.color = 'black';
    }
    return style;
  };

  return (
    <Box
      sx={{
        position: 'relative',
        mb: '1rem',
        p: '1rem',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        borderRadius: '15px',
        ...chatBoxStyle(),
        ...(isSentType
          ? {
              // Tail for sent messages (bottom-right corner)
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '-8px',
                right: '10px', // Adjust this as needed
                width: 0,
                height: 0,
                borderLeft: '5px solid transparent',
                borderRight: '5px solid transparent',
                borderTop: '10px solid #00A1FF',
              },
            }
          : {
              // Tail for received messages (bottom-left corner)
              '&::before': {
                content: '""',
                position: 'absolute',
                bottom: '-10px',
                left: '10px', // Adjust if needed
                width: 0,
                height: 0,
                borderLeft: '5px solid transparent',
                borderRight: '5px solid transparent',
                borderTop: '10px solid #F0F7FF',
              },
            }),
      }}
      onMouseOver={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
    >
      <Stack direction="column">
        {chat.type !== 'sent' && (
          <Box
            sx={{
              visibility: mouseOver ? 'visible' : 'hidden',
              position: 'absolute',
              top: '0',
              transition: 'all 0.3s ease-in-out',
              right: '10px',
            }}
          >
            <FileCopyOutlinedIcon
              onClick={copyToClipboard}
              sx={{ color: '#0066cc', cursor: 'pointer',fontSize: 'medium' }}
            />
          </Box>
        )}
        {chat.mathFormat && (
          <MathJax hideUntilTypeset="every" dynamic>
            <div dangerouslySetInnerHTML={{ __html: chat.text }} />
          </MathJax>
        )}
        {!chat.mathFormat && <Markdown>{chat.text}</Markdown>}
      </Stack>
    </Box>
  );
};

export default memo(AiChatHistory);
